import React, { useCallback, useEffect, useState } from 'react';
import { useField, useFormikContext } from 'formik';
import dayjs from 'dayjs';
import DatePicker from 'react-datepicker';
import { IFormItem } from '../form-item.type';
import { FormErrorMsg } from '../form-error-msg';

interface ICalendar extends IFormItem {
  placeholder?: string;

  /**
   * @param date string ISO 8601
   * @see https://en.wikipedia.org/wiki/ISO_8601
   */
  onChange?: (date: string) => void;

  /** Default: false. */
  showTime?: boolean;

  /** Default: false. */
  showOnlyYear?: boolean;

  showYearDropdown?: boolean;

  value?: Date | string;
}

export function Calendar({
  name,
  onChange,
  placeholder,
  showTime = false,
  showOnlyYear = false,
  disabled,
  value,
  showYearDropdown = true,
}: ICalendar) {
  const { setFieldTouched } = useFormikContext();

  const [field, , helper] = useField<string>(name);
  const [selectedDate, setSelectedDate] = useState(field.value ? dayjs(field.value).toDate() : null);

  useEffect(() => {
    if (!value) return;

    setSelectedDate(value?.toString().trim() ? dayjs(value).toDate() : null);
  }, [value]);

  const handleCalendarChange = useCallback(
    (date: Date) => {
      const selectedDateAsStr = date ? date.toISOString() : '';

      helper.setValue(selectedDateAsStr);
      onChange && onChange(selectedDateAsStr);
      setSelectedDate(date);
    },
    [helper, onChange]
  );
  const handleCalendarChangeRaw = useCallback(() => {
    setFieldTouched(field.name, true, true);
  }, [field.name, setFieldTouched]);

  return (
    <div className='form-calendar-wrapper'>
      <div className='form-calendar-control'>
        <DatePicker
          selected={selectedDate}
          dateFormat={showOnlyYear ? 'yyyy' : showTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
          placeholderText={placeholder || (showOnlyYear ? 'yyyy' : showTime ? 'dd/mm/yyyy hh:mm' : 'dd/mm/yyyy')}
          className='form-control'
          name={name}
          // value={value}
          onChange={handleCalendarChange}
          onBlur={field.onBlur}
          dateFormatCalendar='MMMM'
          showTimeSelect={showTime}
          timeFormat='HH:mm'
          disabled={disabled}
          autoComplete='off'
          showYearDropdown={showYearDropdown}
          dropdownMode='select'
          showYearPicker={showOnlyYear}
          onChangeRaw={handleCalendarChangeRaw}

          // minDate={dayjs().toDate()}
          // minTime={minTime}
          // maxTime={dayjs().endOf('day').toDate()}
        />
        <i className='far fa-calendar-alt icon'></i>
      </div>

      <FormErrorMsg name={name} />
    </div>
  );
}
